/* eslint-disable no-plusplus */
import { EVENT_VISIBILITY_CHANGE } from '../settings';
import { Detector, EventListenerCallback, OnDetectionCallback } from '../types';

class VisibilityChangeDetector<T> implements Detector<T> {
  eventListenerCallback: EventListenerCallback | null;

  onDetection: OnDetectionCallback<T>;

  constructor(
    onDetection?: OnDetectionCallback<T>,
  ) {
    this.onDetection = (...args) => {
      onDetection?.apply(this, args);
    };
    this.eventListenerCallback = null;
  }

  start() {
    if (this.eventListenerCallback) {
      return this;
    }
    this.eventListenerCallback = (e: Event) => {
      const element = e.target;
      if (element) {
        const startTime = Date.now();
        this.onDetection(element as Element, e, startTime);
      }
    };
    document.addEventListener(EVENT_VISIBILITY_CHANGE, this.eventListenerCallback);
    return this;
  }

  stop() {
    if (this.eventListenerCallback) {
      window.removeEventListener(EVENT_VISIBILITY_CHANGE, this.eventListenerCallback);
      this.eventListenerCallback = null;
    }
    return this;
  }
}

export default VisibilityChangeDetector;
